<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import {
  SIDEBAR_MENU_ITEM_ACTIVE,
  SIDEBAR_MENU_ITEM_BASE,
  SIDEBAR_MENU_ITEM_INACTIVE,
  SIDEBAR_MENU_ICON_ACTIVE,
  SIDEBAR_MENU_ICON_INACTIVE,
} from './sidebarMenuItemClasses';

const { t } = useI18n();
const route = useRoute();

const isActive = computed(() => route.name === 'search');
</script>

<template>
  <li>
    <RouterLink
      :to="{ name: 'search' }"
      :class="[
        SIDEBAR_MENU_ITEM_BASE,
        isActive ? SIDEBAR_MENU_ITEM_ACTIVE : SIDEBAR_MENU_ITEM_INACTIVE,
      ]"
    >
      <span
        class="flex-shrink-0 i-lucide-search size-5"
        :class="
          isActive ? SIDEBAR_MENU_ICON_ACTIVE : SIDEBAR_MENU_ICON_INACTIVE
        "
      />
      <span class="truncate">
        {{ t('COMBOBOX.SEARCH_PLACEHOLDER') }}
      </span>
    </RouterLink>
  </li>
</template>
